import { useEffect, useState } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

// Images already downloaded in this session: attachment url -> object URL
const cache = new Map()

// <img> for a chat attachment. It sends the login token, so it also works when /uploads is protected.
const AuthImage = ({ src, alt = '', sx, onClick, ...rest }) => {
  const api = useAxiosPrivate()
  const [url, setUrl] = useState(cache.get(src) || null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!src) return

    if (cache.has(src)) {
      setUrl(cache.get(src))
      return
    }

    let cancelled = false
    setFailed(false)

    api
      .get(src, { responseType: 'blob' })
      .then((res) => {
        const objectUrl = URL.createObjectURL(res.data)
        cache.set(src, objectUrl)
        if (!cancelled) setUrl(objectUrl)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })

    return () => {
      cancelled = true
    }
  }, [src, api])

  if (failed) {
    return (
      <Box sx={{ px: 1, py: 0.5, opacity: 0.7 }}>
        <Typography variant="caption">Image unavailable{alt ? `: ${alt}` : ''}</Typography>
      </Box>
    )
  }

  if (!url) {
    return (
      <Box sx={{ width: 120, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={20} />
      </Box>
    )
  }

  return <Box component="img" src={url} alt={alt} onClick={onClick} sx={sx} {...rest} />
}

export default AuthImage